<template>
    <b-modal
        id="updateKeyAccount"
        title="Update Account"
        ref="updateKeyAccount"
        @hidden="closeModal"
    >
        <div class="modal-form">
            <b-row>
                <b-col>
                    <h1 class="key-account-customer-label">
                        Customer Name
                    </h1>
                    <h2 class="key-account-customer-name">
                        {{ firstname + ' ' + lastname }}
                    </h2>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col>
                    <hr class="form-divider" />
                </b-col>
            </b-row>
            <b-row no-gutters>
                <b-col>
                    <b-form-group
                        label="Key Account"
                        class="secondary-label mb-3"
                    >
                        <b-form-select v-model="form.metas">
                            <option v-for="(keyAccountsOption, index) in keyAccountsOptions" :key="index" :value="keyAccountsOption.name">{{ keyAccountsOption.name }}</option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
        </div>
        <div slot="modal-footer">
            <b-button 
                variant="ghost"
                class="btn-cancel"
                style="margin-right: .25rem;"
                @click="closeModal"
                v-bind:disabled="loading"
            >
                Cancel
            </b-button>
            <b-button
                variant="primary"
                style="margin-left: .25rem;"
                v-bind:disabled="loading"
                @click="sendForm"
            >
                <template v-if="loading">Updating...</template>
                <template v-else>Update</template>
            </b-button>
        </div>
    </b-modal>
</template>
<script>
import { mapState } from "vuex";
import _ from "lodash";

export default {
    name: "UpdateKeyAccount",
    props: [
        "status",
        "keyAccountsOptions",
        "uuid",
        "firstname",
        "lastname",
        "metas"
    ],
    data() {
        return {
            form: {
                metas: null
            }
        };
    },
    computed: {
        ...mapState("keyAccount", ["loading", "errors", "modal"])
    },
    methods: {
        closeModal: function() {
            this.$store.commit("keyAccount/setModal", {
                type: "update",
                status: false,
                uuid: null
            });
            // this.form.metas = null;
        },
        sendForm: async function() {
            let param = {
                customer_uuid: this.uuid,
                company_code: this.form.metas
            };

            let _this = this;
            await this.$store
                .dispatch("keyAccount/updateCompanyCode", param)
                .then(function() {
                    if (_.isEmpty(_this.errors)) {
                        _this.$store.dispatch("keyAccount/getFirstPage");
                        _this.closeModal();
                    }
                });
        }
    },
    watch: {
        status: function(status) {
            if (status == true) {
                this.$refs.updateKeyAccount.show();
            } else {
                this.$refs.updateKeyAccount.hide();
            }
        },
        metas: function(metas) {
            this.form.metas = metas;
        }
    }
};
</script>

<style>
</style>
